
import Vue from 'vue';
import { Wrapper } from './styles';

export default Vue.extend({
  name: 'ButtonDatePicker',
  components: { Wrapper },
  props: {
    value: {
      type: Date,
      default: () => new Date(),
    },
    minDate: {
      type: Date,
      default: () => null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
  },
});
